type SupabaseError = {
  code?: string;
  message?: string;
  details?: string | null;
  hint?: string | null;
};

export function convertSupabaseErrorMessage(
  error: SupabaseError | Error | string
): string {
  if (!error) return "An unknown error occurred.";

  const errorMessage =
    typeof error === "string" ? error : (error?.message ?? "");

  if (errorMessage.includes("valid_org_name")) {
    return "Organization name can only contain letters, numbers and hyphens, and cannot start or end with a hyphen.";
  }

  if (errorMessage.includes("subdomain_unique")) {
    return "This organization url already exists";
  }

  if (errorMessage.includes("subdomain_not_www")) {
    return "Organization subdomain cannot be 'www'";
  }

  if (errorMessage.includes("unique_app_name_per_org")) {
    return "An app with this name already exists in your organization.";
  }

  if (
    errorMessage.includes('row-level security policy for table "smart_banners"')
  ) {
    return "Smart banners aren't available here anymore. Reload the page to see the current state of your plan and permissions.";
  }

  if (
    errorMessage.includes("Cannot coerce the result to a single JSON object")
  ) {
    return "Resource not found or you don't have permission to delete it";
  }

  if (
    errorMessage.includes("Unauthorized") ||
    (typeof error !== "string" && "code" in error && error.code === "403")
  ) {
    return "Unauthorized access.";
  }

  return errorMessage || "Something went wrong. Please try again.";
}
